import {
  OMSMetricsRequestSchema,
  SurchargeByCategoryResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getSurchargeByCategory = {
  name: "getSurchargeByCategory" as const,
  input: OMSMetricsRequestSchema,
  output: SurchargeByCategoryResponseSchema,
};
